import React from 'react';
const FilterSidebar = () => {
  return <div className="space-y-6" data-id="element-439">
      <div data-id="element-440">
        <h3 className="font-medium text-gray-800 mb-3" data-id="element-441">Property Type</h3>
        <div className="space-y-2" data-id="element-442">
          {['Apartment', 'House', 'Villa', 'Land', 'Commercial'].map(type => <div key={type} className="flex items-center" data-id="element-443">
              <input type="checkbox" id={`type-${type}`} className="h-4 w-4 text-green-600 focus:ring-green-500 border-gray-300 rounded" data-id="element-444" />
              <label htmlFor={`type-${type}`} className="ml-2 text-gray-700" data-id="element-445">
                {type}
              </label>
            </div>)}
        </div>
      </div>
      <div data-id="element-446">
        <h3 className="font-medium text-gray-800 mb-3" data-id="element-447">Location</h3>
        <div className="space-y-2" data-id="element-448">
          {['Lagos', 'Abuja', 'Port Harcourt', 'Ibadan', 'Kano'].map(location => <div key={location} className="flex items-center" data-id="element-449">
                <input type="checkbox" id={`location-${location}`} className="h-4 w-4 text-green-600 focus:ring-green-500 border-gray-300 rounded" data-id="element-450" />
                <label htmlFor={`location-${location}`} className="ml-2 text-gray-700" data-id="element-451">
                  {location}
                </label>
              </div>)}
        </div>
      </div>
      <div data-id="element-452">
        <h3 className="font-medium text-gray-800 mb-3" data-id="element-453">Price Range</h3>
        <div className="grid grid-cols-2 gap-2" data-id="element-454">
          <div data-id="element-455">
            <label htmlFor="min-price" className="block text-sm text-gray-600 mb-1" data-id="element-456">
              Min
            </label>
            <input type="text" id="min-price" placeholder="₦0" className="w-full px-3 py-1 border border-gray-300 rounded focus:outline-none focus:ring-1 focus:ring-green-500" data-id="element-457" />
          </div>
          <div data-id="element-458">
            <label htmlFor="max-price" className="block text-sm text-gray-600 mb-1" data-id="element-459">
              Max
            </label>
            <input type="text" id="max-price" placeholder="₦500M" className="w-full px-3 py-1 border border-gray-300 rounded focus:outline-none focus:ring-1 focus:ring-green-500" data-id="element-460" />
          </div>
        </div>
      </div>
      <div data-id="element-461">
        <h3 className="font-medium text-gray-800 mb-3" data-id="element-462">Bedrooms</h3>
        <div className="flex flex-wrap gap-2" data-id="element-463">
          {['Any', '1', '2', '3', '4', '5+'].map(bed => <button key={bed} className="px-3 py-1 border border-gray-300 rounded-lg hover:bg-green-50 hover:border-green-500" data-id="element-464">
              {bed}
            </button>)}
        </div>
      </div>
      <div data-id="element-465">
        <h3 className="font-medium text-gray-800 mb-3" data-id="element-466">Bathrooms</h3>
        <div className="flex flex-wrap gap-2" data-id="element-467">
          {['Any', '1', '2', '3', '4', '5+'].map(bath => <button key={bath} className="px-3 py-1 border border-gray-300 rounded-lg hover:bg-green-50 hover:border-green-500" data-id="element-468">
              {bath}
            </button>)}
        </div>
      </div>
      <div data-id="element-469">
        <h3 className="font-medium text-gray-800 mb-3" data-id="element-470">Features</h3>
        <div className="space-y-2" data-id="element-471">
          {['Verified Property', 'Swimming Pool', 'Security', '24/7 Power', 'Furnished', 'Waterfront'].map(feature => <div key={feature} className="flex items-center" data-id="element-472">
              <input type="checkbox" id={`feature-${feature.replace(/\s+/g, '-').toLowerCase()}`} className="h-4 w-4 text-green-600 focus:ring-green-500 border-gray-300 rounded" data-id="element-473" />
              <label htmlFor={`feature-${feature.replace(/\s+/g, '-').toLowerCase()}`} className="ml-2 text-gray-700" data-id="element-474">
                {feature}
              </label>
            </div>)}
        </div>
      </div>
    </div>;
};
export default FilterSidebar;